import { find } from 'lodash-es';

const getFieldConfig = (name: string, config: any) => find(config, { name });

export const getRequired = (name: string, config: any) =>
  getFieldConfig(name, config)?.required;

export const getPattern = (name: string, config: any) =>
  getFieldConfig(name, config)?.pattern;

export const matchPattern =
  (pattern: RegExp, errorText: string) =>
  (value: any): string | undefined =>
    value && !pattern.test(value) ? errorText : undefined;

export const composeValidators =
  (...validators) =>
  (value: any) =>
    validators
      .filter(Boolean)
      .reduce((error, validator) => error || validator(value), undefined);
